import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AuthUser } from "./types";

export const updateAuthUserRequest = (
  userId: string,
  authData: Partial<AuthUser>
) => apiProxyRequest<AuthUser>(`/users/${userId}`, "PATCH", authData);
